import { generateId } from "@@/utilities/generate-id";

const SECTION_THEME_ITEM_SETTINGS = "SECTION_THEME_ITEM_SETTINGS";
type SECTION_THEME_ITEM_SETTINGS = typeof SECTION_THEME_ITEM_SETTINGS;

type SectionThemeItemSettings = {
    _id: string;
    _type: SECTION_THEME_ITEM_SETTINGS;
    hidden?: {
        description?: boolean;
        image?: boolean;
        kicker?: boolean;
        price?: boolean;
        subtitle?: boolean;
        tags?: boolean;
        title?: boolean;
        unit?: boolean;
    };
};

const createSectionThemeItemSettings = (
    params: Omit<SectionThemeItemSettings, "_id" | "_type"> & {
        _id?: string;
    },
): SectionThemeItemSettings => {
    return {
        ...params,
        _id:
            params._id ||
            generateId({ prefix: "section_theme_item_settings__" }),
        _type: SECTION_THEME_ITEM_SETTINGS,
    };
};

export { createSectionThemeItemSettings, SECTION_THEME_ITEM_SETTINGS };
export type { SectionThemeItemSettings };
